import { motion } from "framer-motion";
import { ArrowRight, PlayCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COMPANY, HERO_IMAGE } from "@/lib/sipl-content";

const goTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end overflow-hidden"
    >
      <img
        src={HERO_IMAGE}
        alt="Solar plant"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-sipl-primary/85 via-sipl-primary/70 to-sipl-primary/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-sipl-primary/70 via-transparent to-transparent" />

      <div className="relative z-10 container-x w-full pb-20 md:pb-28 pt-32 md:pt-40">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <div className="text-sm uppercase tracking-[0.25em] text-sipl-accent mb-6 dash-accent">
            Renewable Energy · Waste Management · Infra
          </div>
          <h1 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
            {COMPANY.tagline}
          </h1>
          <p className="mt-6 text-base md:text-lg text-white/85 max-w-2xl leading-relaxed">
            {COMPANY.subtagline}
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <Button
              onClick={() => goTo("#contact")}
              data-testid="hero-cta-proposal"
              className="bg-sipl-accent hover:bg-sipl-accent/90 text-white px-7 h-12 rounded-md"
            >
              Request Proposal <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button
              onClick={() => goTo("#services")}
              data-testid="hero-cta-explore"
              variant="outline"
              className="border-white/70 bg-white/0 text-white hover:bg-white hover:text-sipl-primary px-7 h-12 rounded-md"
            >
              <PlayCircle className="w-4 h-4 mr-2" />
              Explore Solutions
            </Button>
          </div>

          <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-2xl">
            {[
              ["Founded", "2016"],
              ["HQ", "Noida, IN"],
              ["Sectors", "4"],
              ["Empanelled", "PSUs · ULBs"],
            ].map(([k, v]) => (
              <div key={k} className="border-l-2 border-sipl-accent pl-3">
                <div className="text-[10px] uppercase tracking-[0.22em] text-white/60">{k}</div>
                <div className="text-white font-heading text-base font-medium mt-1">{v}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
